import { CustomerItemStatus } from '../store/features/customerUpdates/customerUpdatesSlice';

export const unknownCabinSymbol = '?';

export type CustomerFlightTeam = {
    readonly id: string;
    readonly scheduledDepartureTime?: string;
    readonly scheduledDepartureTimeUtc: string;
    readonly scheduledArrivalTime?: string;
    readonly scheduledArrivalTimeUtc: string;
    readonly iataFlightIdentifier: string;
    readonly departureAirportIata: string;
    readonly arrivalAirportIata: string;
};

export type CustomerInfo = {
    readonly id: number;
    readonly firstName: string;
    readonly lastName: string;
    readonly seatNumber: string;
    readonly cabin: string | null;
    readonly frequentFlyerTier: string | null;
    readonly pnr: string | null;
};

export type CustomerNotificationInfo = {
    readonly unableToNotifyOnUtc: string | null;
    readonly notifiedOnUtc: string | null;
    readonly status: CustomerItemStatus;
};

export type CustomerWithStatuses = {
    readonly customer: CustomerInfo;
    readonly flightTeam: CustomerFlightTeam;
    readonly mishandledBaggage: CustomerNotificationInfo | null;
    readonly lastRebookedFlight: CustomerNotificationInfo | null;
    readonly lastMessage: CustomerNotificationInfo | null;
};

export type CustomerRebookedFlight = {
    readonly flightNumber: string;
    readonly departureAirportIata?: string;
    readonly arrivalAirportIata: string;
    readonly transitAirportsIata?: string;
    readonly scheduledDepartureTime: string;
    readonly scheduledArrivalTime?: string;
    readonly overnightStay: boolean;
    readonly notes?: string;
    readonly groupSize: number;
    readonly notificationInfo: CustomerNotificationInfo;
};

export type CustomerBagReflightLegDateTime = {
    readonly dateString: string;
    readonly timeString: string;
};

export type CustomerBagReflightLeg = {
    readonly id: string;
    readonly flightNumber: string;
    readonly departureAirportIata: string;
    readonly arrivalAirportIata: string;
    readonly scheduledDepartureTime: CustomerBagReflightLegDateTime;
    readonly scheduledArrivalTime: CustomerBagReflightLegDateTime;
};

export type CustomerBag = {
    readonly id: string;
    readonly tag: string;
    readonly missingBagReportNumber: string;
    readonly notificationInfo: CustomerNotificationInfo;
    readonly reflightLegs: readonly CustomerBagReflightLeg[];
};

export type CustomerMishandledBaggageBooking = {
    readonly customer: CustomerInfo;
    readonly bags: readonly CustomerBag[];
};

export type CustomerMishandledBaggage = {
    readonly pnr: string;
    readonly flightTeam: CustomerFlightTeam;
    readonly bookings: readonly CustomerMishandledBaggageBooking[];
};

export type CustomerMessage = {
    readonly messageId: number;
    readonly sentOnUtc: string;
    readonly content: string;
    readonly feedback: string;
    readonly notificationInfo: CustomerNotificationInfo;
};
